import React, { useState, useEffect } from 'react';
import NexolveLogo from '../images/nexolvelogo-new.png';
import '../styles/header.css';

const NavBar = ({ 
  onHomeClick, 
  onAboutClick, 
  onServicesClick, 
  onPortfolioClick, 
  onContactClick 
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Immediately set initial state

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', onClick: onHomeClick },
    { name: 'About Us', onClick: onAboutClick },
    { name: 'Our Services', onClick: onServicesClick },
    { name: 'Client Reviews', onClick: onPortfolioClick },
    { name: 'Careers', onClick: onContactClick },
    { name: 'Contact Us', onClick: onContactClick }
  ];

  return (
    <nav className={`dynamic-navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-wrapper">
        {/* Logo Section */}
        <div className="navbar-logo">
          <img
            src={NexolveLogo}
            alt="Nexolve Logo"
            className="logo-image"
          />
        </div>

        {/* Desktop Navigation */}
        <ul className={`navbar-menu ${isMenuOpen ? 'mobile-open' : ''}`}>
          {navItems.map((item) => (
            <li 
              key={item.name} 
              className="navbar-item"
              onClick={() => {
                item.onClick();
                setIsMenuOpen(false);
              }}
            >
              <span className="navbar-link">
                {item.name}
              </span>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Toggle */}
        <div
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;